import reducer from './reducers';

export { default as i18nSelectors } from './selectors';
export { default as i18nOperations } from './operations';

export default reducer;
